import Immutable from 'immutable';

// type UploadResponse {
//   fileid: String!
//   signedurl: String!
// }

export interface RawUploadResponse {
  fileid: string;
  signedurl: string;
}

export interface UploadResponseData {
  fileid: string;
  signedurl: string;
}

const defaultValues: UploadResponseData = {
  fileid: '',
  signedurl: '',
};

export const UploadResponseFactory = Immutable.Record(
  defaultValues,
  'UploadResponse'
);

export class UploadResponse extends UploadResponseFactory {
  static deserialize(rawUploadResponse: RawUploadResponse): UploadResponse {
    return new UploadResponse({
      ...rawUploadResponse,
    });
  }

  serialize(): RawUploadResponse {
    return this.toJS();
  }
}
